import { StateCreator } from "zustand";
import { Storage } from "../index";

export interface UserInfo {
	fullName: string;
	email: string;
	countryCode: string;
	phoneNumber: string;
	consent: boolean;
}

export type UserLocationInfo = {
	name: string;
	coordinates: {
		longitude: number;
		latitude: number;
	};
	postalCode: string;
	city: string;
	country: string;
};

// INITIAL STATE
export type UserInfoSlice = {
	userInfo: UserInfo;
	setUserInfo: (userInfo: Partial<UserInfo>) => void;
};

const initialState = {
	userInfo: {
		fullName: "",
		email: "",
		countryCode: "",
		phoneNumber: "",
		consent: false,
	},
};

export const createUserInfoSlice: StateCreator<
	Storage,
	[],
	[
		[
			"zustand/persist",
			{
				userInfo: UserInfo;
				userLocationInfo: UserLocationInfo;
			},
		],
	],
	UserInfoSlice
> = (set) => ({
	...initialState,
	setUserInfo: (userInfo: Partial<UserInfo>) =>
		set((state) => {
			return { userInfo: { ...state.userInfo, ...userInfo } };
		}),
});
